import request from '@/util/request'
import {createHelpers} from 'vuex-map-fields'

const {getCompApps} = createHelpers({
  getterType: 'getCompApps',
})

const state = {
  COMP_APPS: [],
  COMP_APP_OPTIONS: {
    MODEL: null
  },
  COMP_APP_DS_URL: null,
}

const GETTERS = {getCompApps}

function fetchCompAppOptions({commit}) {
  return request({
    url: `/comp-app/options`,
    method: 'get',
  }).then((data) => {
    commit('SET_COMP_APP_OPTIONS', data)
  })
}

function fetchCompanyApplications({commit, getters}) {
  const companyId = getters.getSelectedCompany.id;
  return request({
    url: `/comp-app/list/${companyId}`,
    method: 'get',
  }).then((data) => {
    commit('SET_COMP_APPS', data)
  })
}

function generateCompAppDocument({commit, getters}, data) {
  const companyId = getters.getSelectedCompany.id;
  return request({
    url: `/comp-app/generate/${companyId}`,
    method: 'post',
    data,
  }).then((data) => {
    const newApps = [
      data.application,
      ...getters
        .getCompApps('COMP_APPS')
        .filter((app) => app.app_id != data.application.app_id),
    ]
    commit('SET_COMP_APPS', newApps)
  })
}

function refreshCompAppEnvelopes({commit, getters}, data) {
    const companyId = getters.getSelectedCompany.id;
    return request({
        url: `/comp-app/refresh/${companyId}`,
        method: 'post',
        data,
    }).then((data) => {
        const newApps = [
        data.application,
        ...getters
            .getCompApps('COMP_APPS')
            .filter((app) => app.app_id != data.application.app_id),
        ]
        commit('SET_COMP_APPS', newApps)
    })
}

function signCompApp({commit, getters}, data) {
  const companyId = getters.getSelectedCompany.id;
  return request({
    url: `/comp-app/sign/${companyId}`,
    method: 'post',
    data,
  })
    .then((data) => {
      commit('SET_DS_URL', data.url)
    })
    .catch(console.error)
}

function submitCompApp({commit, getters}, data) {
  const companyId = getters.getSelectedCompany.id;
  return request({
    url: `/comp-app/submit/${companyId}`,
    method: 'put',
    data,
  }).then((data) => {
    const newApps = [
      data.application,
      ...getters
        .getCompApps('COMP_APPS')
        .filter((app) => app.app_id != data.application.app_id),
    ]
    commit('SET_COMP_APPS', newApps)
  })
}

function upsertCompApp({commit, getters}, data) {
  const companyId = getters.getSelectedCompany.id;
  return request({
    url: `/comp-app/upsert/${companyId}`,
    method: 'put',
    data,
  }).then((data) => {
    //TODO: Sad path path handling.
    const newApps = [
      data.application,
      ...getters
        .getCompApps('COMP_APPS')
        .filter((app) => app.app_id != data.application.app_id),
    ]
    commit('SET_COMP_APPS', newApps)
  })
}

function signupNewCustomer({commit}, data) {
  return request({
    url: `/comp-app/signup`,
    method: 'post',
    data,
  }).then((data) => {
    commit('SET_SIGNUP_RESPONSE', data)
  })
}

const actions = {
  fetchCompanyApplications,
  fetchCompAppOptions,
  generateCompAppDocument,
  refreshCompAppEnvelopes,
  upsertCompApp,
  signCompApp,
  submitCompApp,
  signupNewCustomer,
}

const mutations = {
  SET_COMP_APPS(state, compApps) {
    state.COMP_APPS = compApps
  },
  SET_COMP_APP_OPTIONS(state, compAppOptions) {
    state.COMP_APP_OPTIONS = compAppOptions
  },
  SET_DS_URL(state, url) {
    state.DS_URL = url
  },
  SET_SIGNUP_RESPONSE(state, response) {
    state.SIGNUP_RESPONSE = response
  },
}

export default {
  namespaced: false,
  state,
  getters: GETTERS,
  actions,
  mutations,
}
